import { BActionIcon } from '@components/BActionIcon/BActionIcon';
import { CircleDiv } from '@components/Filters/Filter/Filter.styles';
import GlobalOverlay from '@components/GlobalOverlay';
import { Popover } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { GetDocumentsByStudioFilter } from '@services/queries/documents/getDocumentsByStudio/getDocumentsByStudio.types';
import { countDocumentsFilter } from '../../logic/countDocumentsFilter';
import { ButtonContainer, useStyles } from './FilterMenu.styles';

interface FilterMenuProps {
  filter: GetDocumentsByStudioFilter;
  content: (close: VoidFunction) => React.ReactNode;
}
export function FilterMenu(props: FilterMenuProps) {
  const { content, filter } = props;
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [filterCount] = countDocumentsFilter(filter);

  return (
    <>
      {opened && <GlobalOverlay />}
      <Popover
        offset={-42}
        position="bottom-end"
        opened={opened}
        onOpen={open}
        onClose={close}
        classNames={classes}
      >
        <Popover.Target>
          <ButtonContainer>
            <BActionIcon
              icon="filter"
              variant="outline"
              size={42}
              onClick={open}
            />
            {filterCount > 0 && <CircleDiv>{filterCount}</CircleDiv>}
          </ButtonContainer>
        </Popover.Target>
        <Popover.Dropdown>{content(close)}</Popover.Dropdown>
      </Popover>
    </>
  );
}
